import { FireableEvent } from 'constants/analyticEvents'
import { useCurrentSite } from 'contexts/SiteConfig'
import { useOrganisationConfig } from 'hooks/UseOrganisationConfig'
import { useEffect, useMemo } from 'react'
import { noop } from 'lodash'

type EventOptions = { [key: string]: string | boolean | number | undefined }

export const fireEvent = (eventName: FireableEvent, eventOptions: EventOptions = {}) => {
  if (window.gtag) {
    window.gtag('event', eventName, {
      ...eventOptions,
    })
  }
}

export const updateUserProperties = (properties: EventOptions) => {
  if (window.gtag) {
    window.gtag('set', 'user_properties', {
      ...properties,
    })
  }
}

export const useHydrateUserProperties = () => {
  const organisationId = useOrganisationConfig()
  const prefersDarkScheme =
    window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches

  useEffect(() => {
    if (organisationId) {
      updateUserProperties({
        organisation_id: organisationId,
        prefers_dark_scheme: prefersDarkScheme,
      })
    }
  }, [organisationId, prefersDarkScheme])
}

export const useAnalytics = () => {
  const site = useCurrentSite()

  return useMemo(() => {
    try {
      return {
        fireEvent: (eventName: FireableEvent, eventOptions: EventOptions = {}) => {
          fireEvent(eventName, {
            site_id: site.id,
            site_name: site.name,
            ...eventOptions,
          })
        },
      }
      // eslint-disable-next-line no-unreachable
    } catch {
      return {
        fireEvent: noop,
      }
    }
  }, [site.id, site.name])
}

export const Analytics = () => {
  useHydrateUserProperties()

  return null
}
